import { Box, Collapse } from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

import { useFirstMountAnimation } from '@/v5/@hooks/auth/login/useFirstMountAnimation';
import { useVisibleAnimation } from '@/v5/@hooks/auth/login/useVisibleAnimation';
import { usePathnameDetect } from '@/v5/@hooks/auth/usePathnameDetect';
import { usePathnameTransition } from '@/v5/@hooks/usePathnameTransition';

import { AuthContent } from '@/v5/components/organisms/AuthContent';
import { AuthLayout } from '@/v5/components/templates/AuthLayout/AuthLayout';

import { styles } from '@/v5/@constants/login';
import { registerPath } from '@/v5/paths';

function AuthPage() {
    const location = useLocation();
    const isRegister = location.pathname === registerPath();
    const shouldAnimate = useFirstMountAnimation();
    const { isVisible, collapseTransition } =
        useVisibleAnimation(shouldAnimate);

    const endingHeight = 500;

    const {
        currentRoute,
        routes,
        routesLevel,
        transition,
        slideVariants,
        isForgotPassword,
        isChangePassword,
    } = usePathnameDetect();

    const { isInitialLoad, getTransitionDirection } = usePathnameTransition({
        currentRoute,
        routes,
        routesLevel,
    });

    const transitionDirection = getTransitionDirection();

    return (
        <AuthLayout hideFooter={isRegister}>
            <Collapse
                in={isVisible}
                endingHeight={endingHeight}
                animateOpacity
                transition={collapseTransition}
                style={{
                    willChange: isVisible ? 'auto' : 'transform, opacity',
                }}>
                <Box
                    position="relative"
                    height="100%" // old height: 496
                    display="flex"
                    alignItems="center">
                    <AnimatePresence
                        initial={false}
                        custom={transitionDirection}>
                        <motion.div
                            key={currentRoute}
                            custom={transitionDirection}
                            variants={slideVariants}
                            initial={isInitialLoad ? false : 'initial'}
                            animate="animate"
                            exit="exit"
                            transition={transition}
                            style={styles.authAnimatedBox}>
                            <AuthContent
                                isForgotPassword={isForgotPassword}
                                isChangePassword={isChangePassword}
                            />
                        </motion.div>
                    </AnimatePresence>
                </Box>
            </Collapse>
        </AuthLayout>
    );
}

export default AuthPage;
